import '../../../../dmView/style/App.css';
import { BoldifyReplace } from '../BoldifyReplace.js';
import { useState } from 'react';

const calcSourceTitle = (title) => {
    if(title === 'XPHB')
        return '2024'

    if(title === 'PHB')
        return '2014'

    return title
}

const ConditionBlock = ({condition, enableCollapse=false}) => {
    const [collapse, setCollapse] = useState(!enableCollapse);

    const handleCollapse = () => {
        if(enableCollapse) {
            setCollapse(!collapse);
        }
    }

    if(!condition) {
        return null;
    } else return (
        <div className='spellBlockContainer'>
            <div className={enableCollapse ? `spellBlockHoverTitle` : ``} onClick={() => handleCollapse()} style={{cursor: enableCollapse ? 'pointer' : 'default'}}>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '5px'}}>
                    <div className='topSpellInfo shadowBox'>
                        <span className='titleFontFamily'><b>{condition?.name}</b> - {condition.objectType}</span>
                    </div>
                    {enableCollapse && 
                        <>
                            <span><i> -  {calcSourceTitle(condition?.source)}</i></span>
                            <div style={{marginLeft: 'auto', cursor: 'pointer', display: enableCollapse ? 'block' : 'none'}}>
                                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                                    verticalAlign: "middle",
                                    transition: "transform 0.2s",
                                    transform: collapse ? "rotate(0deg)" : "rotate(90deg)"
                                }}>
                                    <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </>
                    }
                </div>
                <hr className="lineSeperator" />
            </div>
            <div className='' style={{maxHeight: collapse ? '200px' : '0', overflowY: 'scroll', transition: 'max-height .4s ease-in-out'}}>
                {condition.entries.map(entry => {
                    if(typeof entry === 'string')
                        return <p key={entry} style={{padding: '4px 4px 4px 0px'}}><BoldifyReplace desc={entry}/></p>
                    else if(typeof entry === 'object') {
                        if(entry?.items) {
                            return  <ul className='spellList'>
                                        {entry.items.map(item => {
                                            if(typeof item === 'object') {
                                                if(item.type === 'item') {
                                                    return <li key={item.name}><strong className='titleColor'>{item.name}: </strong><BoldifyReplace desc={item.entry}/> </li>
                                                }
                                                return <>!! missing info !!</>
                                            } 
                                            else if(item?.entries)
                                                return <li key={item.name}><strong className='titleColor'>{item.name}: </strong><BoldifyReplace desc={item.entries.join(" ")}/> </li>
                                            else 
                                                return <li key={item}><BoldifyReplace desc={item}/></li>
                                        })}
                                    </ul>
                        } else if(entry?.entries) {
                            return <ul className='spellList'>
                                        {entry?.entries.map(entry2 => {
                                            if(entry2?.entries)
                                                return <li key={entry2.name}><strong className='titleColor'>{entry2.name}: </strong><BoldifyReplace desc={entry2.entries.join(" ")}/> </li>
                                            else return <>null entry</>
                                        })}
                                    </ul>
                        } else if (entry?.type === 'table') {
                            return <table className='spellTable'>
                                        <tr>
                                            {entry.colLabels.map((label) => {
                                                return <th><BoldifyReplace desc={label} /></th>
                                            })}
                                        </tr>
                                        {entry.rows.map((row) => {
                                            return <tr>
                                                        {row.map((rowData, index) => {
                                                            if(typeof rowData === 'object') {
                                                                return rowData.map((data) => {
                                                                    <td>{data}</td>
                                                                })
                                                            } else {
                                                                return <td className={index ? "" : "spellTableDice"}><BoldifyReplace desc={rowData}/></td>
                                                            }
                                                        })}
                                                    </tr>
                                        })}
                                    </table>
                        } else {
                            return <ul className='spellList' style={{paddingTop: '0', paddingBottom: '0', marginTop: '0', marginBottom: '0'}}>
                                    <li style={{padding: '4px'}}>
                                        <strong className='titleColor'>{entry.name}: </strong><BoldifyReplace desc={entry.entries.join(" ")}/> 
                                    </li>
                                </ul>
                        }
                    } else return null
                })}
                <hr className="lineSeperator" />
                <span>{condition?.source} - {condition?.page}</span>
            </div>
        </div>
    );
}

export default ConditionBlock;
